// utils/pagination.js
export function paginate (array, currentPage, pageSize = 7) {
  const start = currentPage * pageSize
  return array.slice(start, start + pageSize)
}
